module.exports = __webpack_public_path__ + "static/media/Holly Lodge Wardrobes (10).0fd99442.JPG";